import React from "react";
import { motion } from "framer-motion";

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-black overflow-hidden px-6 py-20">

      {/* 🔵 Floating light blobs (parallax style) */}
      <motion.div
        className="absolute top-20 left-10 w-72 h-72 bg-blue-500/20 rounded-full blur-3xl"
        animate={{ y: [0, -20, 0], opacity: [0.7, 1, 0.7] }}
        transition={{ duration: 6, repeat: Infinity }}
      />
      <motion.div
        className="absolute bottom-20 right-10 w-72 h-72 bg-cyan-500/20 rounded-full blur-3xl"
        animate={{ y: [0, 25, 0], opacity: [0.7, 1, 0.7] }}
        transition={{ duration: 7, repeat: Infinity }}
      />

      {/* 🔥 Content container */}
      <div className="relative z-10 max-w-6xl flex flex-col md:flex-row items-center gap-16">

        {/* 📝 Text Section */}
        <motion.div
          className="text-center md:text-left flex-1"
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-6xl font-extrabold text-white leading-tight"
              data-aos="fade-up"
              data-aos-delay="200"
          >
            Smart Technology  
            <span className="text-cyan-400"> & Digital Solutions </span>
            for Modern Businesses
          </h1>

          <p
            className="text-gray-300 text-lg md:text-xl mt-4"
            data-aos="fade-up"
            data-aos-delay="350"
          >
            We build websites, provide IT maintenance and support, and create strategic digital marketing campaigns
            that help your business grow.
          </p>

          <motion.div
            className="mt-8"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8 }}
          >
            <a
              href="/contact"
              className="px-8 py-4 bg-cyan-500 hover:bg-cyan-600 text-white font-semibold rounded-xl shadow-lg 
                        shadow-cyan-500/30 hover:shadow-cyan-500/50 transition-all duration-300"
            >
              Request a Quote
            </a>
          </motion.div>
        </motion.div>

        {/* 🖼 Image Section */}
        <motion.div
          className="flex-1"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          data-aos="fade-left"
        >
          <motion.img
            src="/img/home-code-screen.png"
            alt="Technology Illustration"
            className="w-full max-w-md mx-auto rounded-2xl shadow-lg shadow-cyan-500/20"
            animate={{ y: [0, -8, 0] }}
            transition={{ duration: 4, repeat: Infinity }}
          />
        </motion.div>

      </div>
    </section>
  );
}
